import { Component, EventEmitter, HostListener, Output } from '@angular/core';
import { ViewportOverlayDirective } from '../../../../common/directives/viewport-overlay/viewport-overlay.directive';

@Component({
  selector: 'screening-help',
  standalone: true,
  imports: [],
  hostDirectives: [ViewportOverlayDirective],
  templateUrl: './help.component.html',
  styleUrl: './help.component.css'
})
export class ScreeningHelpComponent {

  @Output() close = new EventEmitter<void>();

  @HostListener('document:keydown.escape', ['$event' as any])
  handleEscapeKey(event: KeyboardEvent) {
    this.closeHelp();
  }

  closeHelp() {
    this.close.emit();
  }
}
